const relative = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto', style: 'short' });
const absolute = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });

const UNITS = [
  ['year', 365 * 24 * 3600],
  ['month', 30 * 24 * 3600],
  ['day', 24 * 3600],
  ['hour', 3600],
  ['minute', 60],
];

export function formatDate(value) {
  return value ? absolute.format(new Date(value)) : '—';
}

// "in 2 hr", "3 days ago"
export function fromNow(value) {
  if (!value) return '';
  const seconds = (new Date(value) - Date.now()) / 1000;
  const [unit, size] = UNITS.find(([, unitSeconds]) => Math.abs(seconds) >= unitSeconds) ?? UNITS[UNITS.length - 1];
  return relative.format(Math.round(seconds / size), unit);
}

export function daysUntil(value) {
  return (new Date(value) - Date.now()) / 86_400_000;
}

const dayFormat = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });

// A YYYY-MM-DD calendar day, without shifting it through UTC
export function formatDay(value) {
  const [year, month, day] = value.split('-').map(Number);
  return dayFormat.format(new Date(year, month - 1, day));
}
